"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaPreview = void 0;
var glightbox_1 = __importDefault(require("glightbox"));
var GeneralSettings_1 = require("../constants/GeneralSettings");
require("glightbox/dist/css/glightbox.min.css");
var resolveType = function (media) {
    var type = media.type, extension = media.extension;
    if (type === GeneralSettings_1.MEDIA_TYPES.VIDEO) {
        return 'video';
    }
    if (extension.toLowerCase() !== 'pdf') {
        return ([
            GeneralSettings_1.MEDIA_TYPES.IMAGE,
            GeneralSettings_1.MEDIA_TYPES.DOCUMENT,
            GeneralSettings_1.MEDIA_TYPES.FLOOR_PLAN,
            GeneralSettings_1.MEDIA_TYPES.APARTMENT_PLAN,
            GeneralSettings_1.MEDIA_TYPES.BUILDING_PLAN,
        ].includes(type) && 'image');
    }
    return 'external';
};
var useMediaPreview = function () {
    return function (media, index) {
        if (media === void 0) { media = []; }
        if (index === void 0) { index = 0; }
        var gallery = glightbox_1.default({
            elements: media.map(function (m) { return ({
                href: getHref(m),
                type: resolveType(m),
            }); }),
            autoplayVideos: true,
            startAt: index,
        });
        gallery.open();
    };
};
exports.useMediaPreview = useMediaPreview;
var getHref = function (media) {
    return GeneralSettings_1.MEDIA_TYPES.IMAGE === media.type ? '/r' + media.path + '?0x0' : media.path;
};
